import React, { useState } from 'react';
import classnames from 'classnames';
import { InputCheckbox } from '../Inputs';
import TableRow from './TableRow/TableRow';

const RefinanceLoanTable = ({
  setCheckedOwners,
  totalAdjustedPremium,
  className,
  refinanceLoanResults,
  title,
  subtitle,
}) => {
  // destructuring the values of the results.
  const {
    newLoanPremium,
    existingLoanPremium,
    percentCredit,
    resultingCredit,
  } = refinanceLoanResults;

  return (
    <div className="calc__box">
      <h1 className="calc__title">{title}</h1>
      <h2 className="calc__title--sub">{subtitle}</h2>
      <table className={classnames('table', className)}>
        <tbody>
          <TableRow
            label="New Loan Premium"
            valueType="currency"
            value={newLoanPremium}
          />
          <TableRow
            label="Existing Loan Premium"
            valueType="currency"
            value={existingLoanPremium}
          />
          <TableRow
            label="% Credit"
            valueType="percentage"
            value={percentCredit * 100 + '%'}
          />
          <TableRow
            label="Resulting Credit"
            valueType="currency"
            value={resultingCredit}
          />
          <TableRow
            className="tr--result"
            label="Adjusted Premium"
            valueType="currency"
            value={totalAdjustedPremium}
          />
        </tbody>
      </table>
    </div>
  );
};

export default RefinanceLoanTable;
